/// <reference path="Chart.js" />
import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';
import Frame from './Frame';
import IFrame from './IFrame';
import loader from '../../src/components/css/dark/img/loader.gif';
const { AbortController } = window;

class BarChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            chartData: [],
            ColorCode: this.props.ColorCode,
            XlabelString: this.props.XlabelString,
            YlabelString: this.props.YlabelString,
            IFrameId: this.props._Index,
            IsDataLoaded: false,
            noDataDisplay: ''
        }
        this.abortController = null;
        this.debounceTimer = null;
    }
    componentDidUpdate(prevProp) {
        try {
            if (prevProp.data.RequestJson != this.props.data.RequestJson && this.props.data.type == "Bar") {
                this.fetchData_locally();
            }
        }
        catch (error) { }
    }
    componentDidMount() {
        if (this.props.data.type == "Bar") {
            this.fetchData_locally();
        }
        window.Chart.defaults.global.defaultFontFamily = `'Fira Sans', sans-serif`;
    }
    componentWillUnmount() {
        if (this.abortController) {
            this.abortController.abort();
        }
    }
    fetchData_locally() {
        // Cancel any previous pending request
        if (this.abortController) {
            this.abortController.abort();
        }
        // Create a new AbortController for this request
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        let data_available = '';
        this.setState({
            IsDataLoaded: false
        });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
            body: this.props.data.RequestJson,
            signal //  attach abort signal here
        };
        return fetch(this.props.data.url, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    // data not available
                    data_available = apidata[0].columnDataSet[0].data.length <= 1 ? 'No Data Available' : '';
                    if (!signal.aborted) {
                        this.setState({
                            IsDataLoaded: true,
                            noDataDisplay: data_available
                        });
                    }
                    this.setState({
                        ...this.state,
                        IsDataLoaded: true,
                        chartData: [
                            {
                                labels: apidata[0].columnDataSet[0].labels,
                                datasets: [
                                    {
                                        label: apidata[0].columnDataSet[0].toplabel,
                                        data: apidata[0].columnDataSet[0].data,
                                        backgroundColor: this.state.ColorCode,
                                        borderColor: this.state.ColorCode,
                                        BorderRadius: this.state.BorderRadius
                                    }
                                ]
                            }
                        ],
                        options: apidata[0].columnDataSet[0].isdatechart ? {
                            tooltips: {
                                backgroundColor: '#fff',
                                titleFontColor: '#8ba6c1',
                                borderWidth: 1,
                                borderColor: '#dde5ed',
                                titleFontFamily: "'Fira Sans', sans-serif",
                                titleFontSize: 12,
                                bodyFontFamily: "'Fira Sans', sans-serif",
                                bodyFontSize: 16,
                                bodyFontColor: '#1d252d',
                                xPadding: 10,
                                titleFontStyle: "normal",
                                bodyFontStyle: 600,
                                tooltipFontFamily: "'Fira Sans', sans-serif"
                            },
                            scales: {
                                yAxes: [{
                                    ticks: {
                                        fontColor: "#8ba6c1",
                                        fontSize: 14,
                                        beginAtZero: true
                                    },
                                    gridLines: {
                                        //borderDash: [4, 2],
                                        //color: "#354b5e"
                                        lineWidth: 0,
                                        display: false,
                                        drawBorder: false
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: this.state.YlabelString,
                                        fontFamily: "'Fira Sans', sans-serif",
                                        fontColor: '#8ba6c1',
                                        fontSize: 14
                                    }
                                }],
                                xAxes: [{
                                    type: 'time',
                                    offset: true,
                                    categorySpacing: 15,
                                    time: {
                                        unit: this.props.data.interval
                                    },
                                    gridLines: {
                                        lineWidth: 0,
                                        display: false,
                                        drawBorder: false
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: this.state.XlabelString,
                                        fontFamily: "'Fira Sans', sans-serif",
                                        fontColor: '#8ba6c1',
                                        fontSize: 14
                                    }
                                }],
                            },
                            legend: {
                                labels: {
                                    // This more specific font property overrides the global property
                                    fontColor: '#8ba6c1'
                                },
                                display: false
                            },
                            maintainAspectRatio: false,
                            responsive: true,
                            width: 500,
                            height: 300,
                            noDataDisplay: data_available
                        } : {
                                noDataDisplay: data_available,
                                tooltips: {
                                    backgroundColor: '#fff',
                                    titleFontColor: '#8ba6c1',
                                    borderWidth: 1,
                                    borderColor: '#dde5ed',
                                    titleFontFamily: "'Fira Sans', sans-serif",
                                    titleFontSize: 12,
                                    bodyFontFamily: "'Fira Sans', sans-serif",
                                    bodyFontSize: 16,
                                    bodyFontColor: '#1d252d',
                                    xPadding: 10,
                                    titleFontStyle: "normal",
                                    bodyFontStyle: 600,
                                    tooltipFontFamily: "'Fira Sans', sans-serif"
                                },
                                maintainAspectRatio: false,
                                responsive: true,
                                //title: {
                                //    display: true,
                                //    text: topsum
                                //},
                                legend: {
                                    labels: {
                                        // This more specific font property overrides the global property
                                        fontColor: '#8ba6c1)'
                                    },
                                    display: false
                                },
                                scales: {
                                    yAxes: [{
                                        ticks: {
                                            fontColor: "#8ba6c1",
                                            fontSize: 14,
                                            beginAtZero: true
                                        },
                                        gridLines: {
                                            lineWidth: 0,
                                            display: false,
                                            drawBorder: false
                                        },
                                        scaleLabel: {
                                            display: true,
                                            labelString: this.state.YlabelString,
                                            fontFamily: "'Fira Sans', sans-serif",
                                            fontColor: '#8ba6c1',
                                            fontSize: 14
                                        }
                                    }],
                                    xAxes: [{
                                        offset: true,
                                        barThickness: 15,
                                        maxBarThickness: 15,
                                        minBarLength: 3,
                                        ticks: {
                                            autoSkip: true,
                                            maxTicksLimit: 5,
                                            fontColor: "#8ba6c1",
                                            fontSize: 14
                                        },
                                        gridLines: {
                                            lineWidth: 0,
                                            display: false,
                                            drawBorder: false
                                        },
                                        scaleLabel: {
                                            display: true,
                                            labelString: this.state.XlabelString,
                                            fontFamily: "'Fira Sans', sans-serif",
                                            fontColor: '#8ba6c1',
                                            fontSize: 14
                                        }
                                    }]
                                }

                            }
                    });
                }
                catch (error) {
                }
            }).catch(err => {
                if (err.name === "AbortError") {
                    // Expected cancel, just ignore
                    //console.log("Fetch request aborted");
                    return;
                }
                // Unexpected error
                //console.error("Fetch error:", err);
                this.setState({
                    IsDataLoaded: true,
                    noDataDisplay: 'Error while loading data'
                });
            });
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
    render() {
        return (
            <div>
                {this.state.IsDataLoaded ? '' : (<div className="loader-section"><div className="theme-loader"></div></div>) }
                <div id={this.state.IFrameId} scrolling="no" key={"graph-frame" + this.state.IFrameId}>
                    {
                        this.state.chartData.length > 0 && this.state.chartData[0].labels.length > 0 && this.state.chartData != null ?

                            <div className="myBarChart">
                                {this.state.chartData != null ?
                                    this.state.chartData.map((item, index) => {
                                        return <Bar data={item} options={this.state.options} key={index} />
                                    }) : null
                                }

                            </div>
                            : <span className="data-not-found">{this.state.noDataDisplay}</span>
                    } 
                </div>
                </div>
        )

    }

}
export default BarChart;